export enum WarehouseReceiptListItemAction {
  Approve,
  Edit,
  Preview,
  Remove,
}
